let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bifbn")).then(() => parcelRequire('1qgZZ'));